import { Provider } from '@angular/core';
import { signalStore } from '@ngrx/signals';
import { adminState } from './admin.state';
import { AdminStateService } from './admin-state.service';

export const AdminApplicationStore = signalStore(adminState());

export function provideAdminApplicationState(): Provider[] {
	return [AdminApplicationStore, AdminStateService];
}
